const language = {
	spanish: {
		function_1: "Sensores de medición de combustible",
		function_2: "Sensores de temperatura",
		function_3: "OBDII (Dispositivos de diagnóstico)",
		function_4: "Cerraduras electromecánicas",
		function_5: "CanBus",
		function_6: "Kits de voz",
		function_7: "Video en tiempo real",
	},
	english: {
		function_1: "Fuel measuring sensors",
		function_2: "Temperature sensors",
		function_3: "OBDII (Diagnostic devices)",
		function_4: "Electromechanical locks",
		function_5: "CanBus",
		function_6: "Voice kits",
		function_7: "Real-time video",
	},
};

export default language;